import { render, staticRenderFns } from "./btn-yzm.vue?vue&type=template&id=1ac33743&scoped=true&"
import script from "./btn-yzm.vue?vue&type=script&lang=js&"
export * from "./btn-yzm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac33743",
  null
  
)

export default component.exports